import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=bd6a60ae&scoped=true"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"
import style0 from "./Register.scss?vue&type=style&index=0&id=bd6a60ae&prod&scoped=true&lang=scss&external"
import style1 from "./Register.vue?vue&type=style&index=1&id=bd6a60ae&prod&lang=scss"
import style2 from "./Register.vue?vue&type=style&index=2&id=bd6a60ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6a60ae",
  null
  
)

export default component.exports